export default {
  title: 'Confirmation de votre commande',

  confirm: {
    title: 'Merci %{firstName} !',
    initial:
      'Votre commande a bien été prise en compte, vous allez recevoir un mail récapitulatif.',
    completion:
      'Votre commande a bien été mise à jour, vous recevrez tous vos articles en même temps.',
    loyaltypoints: 'Une fois votre commande livrée, vos miams seront crédités à votre compte.',
  },

  complete: {
    title: 'Vous avez oublié quelque chose ?',
    message: 'Vous avez <b>jusqu’à %{completableUntil}</b> pour ajouter des articles !',
  },
};
